import { createModule } from '../../createModule';
export const createAuditAPI = createModule(({ http }) => {
    return {
        approve: async (params) => {
            const res = await http.post('/v2/audit/approve', { body: params });
            return res;
        },
    };
});
